import { createFileRoute, redirect } from '@tanstack/react-router'

import type { TProfileResponse } from '@/api/auth/types'

import SignInPage from '@/components/pages/auth/sign-in/containers/SignInPage'

export const Route = createFileRoute('/auth/sign-in')({
  beforeLoad: ({ context }) => {
    const profile = context.profile as TProfileResponse | null | undefined
    if (context.isAuthenticated && profile?.password_changed_at) {
      throw redirect({ to: '/', replace: true })
    }
  },
  validateSearch: (search: Record<string, unknown>) => ({
    error: search.error as string | undefined | null
  }),
  loaderDeps: ({ search }) => ({ error: search.error }),
  component: SignInPage
})
